import { IconButton, Box } from '@chakra-ui/react';
import { type FunctionComponent, type ReactNode, useState } from 'react';
import cx from 'classnames';
import { ReactComponent as VerticalDots } from '../assets/svg/VerticalDots.svg';
import { ReactComponent as Close } from '../assets/svg/Close.svg';

interface Props {
  children: ReactNode;
}

export const ButtonsMenu: FunctionComponent<Props> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box>
      <Box
        className={cx('buttons-menu-overlay', { open: isOpen })}
        onBlur={() => {
          setIsOpen(false);
        }}
      >
        {children}
      </Box>

      <IconButton
        icon={isOpen ? <Close /> : <VerticalDots />}
        aria-label="Toggle Menu"
        variant="secondary"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      />
    </Box>
  );
};
